export default "__VITE_ASSET__CrBDEIHe__"